import { useState } from 'react';
import type { ScenarioProjection } from '../domain/types';
import { ScenarioMissionTemplate } from './ScenarioMissionTemplate';
export const templateDirections = [
  {
    id: 'formed',
    name: '高层火灾综合任务模板',
    description: '查阅当前已形成成员的完整阶段结构、依赖、授权点声明与 Unknown。',
    focus: '总体阶段结构 / 信息检查点 / 人工授权边界',
  },
  {
    id: 'life',
    name: '人员疏散与生命搜索重点',
    description: '研究人员分布、辅助疏散与生命搜索如何组织。当前没有正式成员。',
    focus: '人员位置 / 疏散路线 / 搜救与进入条件',
  },
  {
    id: 'machine',
    name: '机器先行侦察重点',
    description: '研究远距观察、空间检查与人工判断的衔接。当前没有正式成员。',
    focus: '技术适用条件 / 远程观察 / 人工审核与备选方案',
  },
] as const;
export function ScenarioTemplateSelector({
  data,
  developmentLoopbackOrigin,
  onSource,
  onSop,
}: {
  readonly data: ScenarioProjection;
  readonly developmentLoopbackOrigin?: string;
  readonly onSource: () => void;
  readonly onSop: () => void;
}) {
  const [selected, setSelected] = useState<(typeof templateDirections)[number]['id']>('formed');
  const direction = templateDirections.find((item) => item.id === selected)!;
  return (
    <section className="scc-panel scc-study">
      <header>
        <h2>
          任务模板选择与比较 <span>MissionTemplate</span>
        </h2>
        <p>一个已形成候选成员，两个尚未形成的研究方向。</p>
      </header>
      <div className="scc-panel-body">
        <div className="scc-template-options">
          {templateDirections.map((item) => (
            <button
              className="scc-template-option"
              key={item.id}
              aria-pressed={selected === item.id}
              data-template-direction={item.id}
              onClick={() => setSelected(item.id)}
            >
              <span className={'scc-chip ' + (item.id === 'formed' ? 'scc-green' : 'scc-warn')}>
                {item.id === 'formed' ? '已形成候选成员' : '研究方向 · 未形成'}
              </span>
              <h3>{item.name}</h3>
              <p>{item.description}</p>
              <strong>{selected === item.id ? '正在查看' : '查看研究方向'} →</strong>
            </button>
          ))}
        </div>
        <div className="scc-template-detail" data-selected-template={selected}>
          <h2>当前选择：{direction.name}</h2>
          <p>{direction.focus}</p>
          {selected === 'formed' ? (
            <>
              <div className="scc-stat-row">
                <span>
                  阶段声明 <strong>T0–T14 · 15 个阶段</strong>
                </span>
                <span>
                  authorizationPoint <strong>11 true / 4 false</strong>
                </span>
              </div>
              <p className="scc-caption">
                以上为 committed MT v1 原始声明，来源 {data.provenance.missionTemplatePin.id}
                ，不是实际授权。完整阶段 / 依赖 / Unknown 通过下方既有精确读取链查看。
              </p>
              <ScenarioMissionTemplate
                key="formed"
                {...(developmentLoopbackOrigin ? { developmentLoopbackOrigin } : {})}
              />
              <button className="scc-text-button" onClick={onSource}>
                查看模板完整 pin 与来源 →
              </button>
            </>
          ) : (
            <div className="scc-notice" data-read-status="PLANNED">
              尚无正式模板 · 无 pin · 无版本 / digest ·
              阶段及依赖未形成。没有精确读取入口，也不会发出 Backend 请求。须由合法 Scenario Owner
              形成内容后再消费。
            </div>
          )}
          <div className="scc-notice">
            模板不是运行中的 Mission。机器参与与 Human Boundary 均需独立验证；false
            不代表无需人工批准。本地 SOP 仍缺 mandate，不能作为机构预案。
          </div>
        </div>
        <button className="scc-primary" onClick={onSop}>
          下一步：本地 SOP 与适用性 →
        </button>
      </div>
    </section>
  );
}
